export default {
  postStatus: {
    draft: '草稿',
    published: '发布',
    recycled: "垃圾"
  },
  postType: {
    AR: 'AR资讯',
    HEALTH: '健康资讯',
  },
  sex: {
    male: '男',
    female: '女',
    unknown: '未知'
  },
  TellOilOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '待充值' },
    Delivered: { type: 'success', name: '已充值' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  mahuaOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '出餐中' },
    Delivered: { type: 'success', name: '待取餐' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
  localOrderStatus: {
    None: { type: 'info', name: '待付款' },
    Payed: { type: 'warning', name: '已支付' },
    Delivered: { type: 'success', name: '已核销' },
    Completed: { type: 'success', name: '已完成' },
    Refunded: { type: 'danger', name: '已退单' },
    Cancel: { type: 'danger', name: '已取消' },
    Fail: { type: 'danger', name: '失败' },
  },
}